import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportRisk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 154,
	height: 124,
	viewBox: "14.77 26.45 154.23 124.25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M37.9764 55.7525C50.4508 41.6675 68.9673 32.3296 86.7885 40.8032C95.5518 44.97 101.124 53.829 110.188 57.4441C119.353 61.0996 127.754 55.3481 136.877 54.2324C147.892 52.8854 159.507 59.4678 163.474 69.862C167.756 81.0794 162.694 95.2645 152.203 101.446C143.149 106.781 131.986 106.167 121.975 109.218C113.31 111.858 105.485 117.369 100.03 124.673C96.8797 128.891 94.4941 133.687 90.9164 137.548C81.0152 148.236 63.6235 149.136 50.998 142.478C38.3725 135.82 29.9444 123.181 24.4647 109.946C22.3598 104.862 20.5927 99.5095 20.5739 93.9637C20.5464 85.8552 24.2214 78.1761 27.8143 70.8363C30.3755 65.6041 33.8445 60.4178 37.9764 55.7525Z",
			fill: "#EEEEF9"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_275_40)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "mask0_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 119,
					y: 61,
					width: 2,
					height: 2,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M119.837 61.9205C119.835 62.0579 119.888 62.1903 119.982 62.2899C120.076 62.3896 120.206 62.4486 120.343 62.4547C120.41 62.4558 120.476 62.4434 120.538 62.4183C120.6 62.3931 120.656 62.3558 120.703 62.3084C120.751 62.261 120.788 62.2047 120.813 62.1426C120.838 62.0806 120.85 62.0141 120.849 61.9472C120.85 61.81 120.798 61.6777 120.703 61.5781C120.609 61.4784 120.48 61.4193 120.343 61.4131H120.33C120.264 61.4137 120.199 61.4273 120.138 61.4533C120.078 61.4792 120.023 61.5169 119.977 61.5642C119.931 61.6114 119.895 61.6673 119.871 61.7286C119.847 61.7899 119.835 61.8547 119.837 61.9205Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask0_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M120.021 61.0211L119.432 62.2697L120.663 62.8519L121.252 61.6033L120.021 61.0211Z",
						fill: "url(#paint0_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask1_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 121,
					y: 61,
					width: 2,
					height: 2,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M121.916 61.9739C121.914 62.1109 121.965 62.2432 122.059 62.3429C122.153 62.4426 122.282 62.5018 122.419 62.508C122.485 62.509 122.551 62.4966 122.613 62.4715C122.675 62.4464 122.731 62.4091 122.777 62.3618C122.824 62.3146 122.861 62.2584 122.886 62.1965C122.911 62.1347 122.922 62.0685 122.921 62.0019C122.923 61.8651 122.872 61.7328 122.778 61.6331C122.684 61.5335 122.555 61.4742 122.419 61.4678H122.405C122.34 61.4686 122.275 61.4823 122.215 61.5082C122.155 61.5341 122.101 61.5717 122.055 61.6187C122.01 61.6658 121.974 61.7214 121.95 61.7823C121.926 61.8433 121.915 61.9084 121.916 61.9739Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask1_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M122.099 61.0794L121.512 62.3231L122.738 62.9025L123.325 61.6587L122.099 61.0794Z",
						fill: "url(#paint1_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask2_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 123,
					y: 61,
					width: 2,
					height: 2,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M123.987 62.028C123.984 62.1646 124.035 62.2969 124.129 62.3966C124.222 62.4963 124.351 62.5557 124.487 62.5621C124.553 62.563 124.619 62.5506 124.68 62.5255C124.742 62.5004 124.797 62.4631 124.844 62.416C124.891 62.3689 124.927 62.3129 124.952 62.2512C124.976 62.1896 124.988 62.1237 124.987 62.0573C124.989 61.9208 124.938 61.7886 124.845 61.6889C124.752 61.5892 124.623 61.5298 124.487 61.5232H124.474C124.408 61.5241 124.344 61.5378 124.284 61.5637C124.224 61.5896 124.17 61.6271 124.125 61.674C124.08 61.721 124.044 61.7764 124.021 61.8372C123.997 61.8979 123.985 61.9627 123.987 62.028Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask2_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M124.166 61.1369L123.581 62.3759L124.801 62.9524L125.385 61.7134L124.166 61.1369Z",
						fill: "url(#paint2_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask3_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 86,
					y: 71,
					width: 15,
					height: 17,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M92.2581 86.098V84.9909C92.26 84.6295 92.1539 84.2758 91.9532 83.9753C91.7525 83.6748 91.4665 83.4414 91.1321 83.305C89.866 82.8129 88.7981 81.9152 88.095 80.752C87.3918 79.5888 87.093 78.2254 87.2451 76.8744C87.4373 75.4576 88.1045 74.1482 89.1374 73.1606C90.1704 72.173 91.5078 71.5659 92.9306 71.4386C93.1782 71.4144 93.4269 71.4035 93.6757 71.4059C95.2363 71.4135 96.7416 71.9855 97.9142 73.0164C98.7053 73.7 99.3069 74.5762 99.6609 75.5605C100.015 76.5447 100.109 77.6037 99.9348 78.6351C99.7605 79.6666 99.3233 80.6355 98.6655 81.4484C98.0077 82.2613 97.1516 82.8906 96.1799 83.2756C95.8482 83.4165 95.5655 83.6523 95.3674 83.9535C95.1692 84.2546 95.0643 84.6076 95.0658 84.9682V86.0706C95.0604 86.303 94.9643 86.5241 94.7979 86.6864C94.6316 86.8486 94.4082 86.9392 94.176 86.9386L93.1507 86.95H93.1407C93.0264 86.9523 92.9129 86.9319 92.8066 86.8902C92.7002 86.8484 92.6032 86.786 92.521 86.7066C92.4388 86.6272 92.373 86.5323 92.3276 86.4274C92.2821 86.3225 92.2579 86.2096 92.2562 86.0953M92.8986 71.1782C91.4157 71.3103 90.0217 71.9426 88.9449 72.9715C87.8682 74.0005 87.1727 75.3651 86.9723 76.8417C86.8136 78.2494 87.125 79.6701 87.8578 80.8821C88.5907 82.0941 89.7038 83.0292 91.0234 83.5414C91.3103 83.6589 91.5554 83.8597 91.7272 84.1179C91.899 84.3762 91.9896 84.68 91.9873 84.9903V86.098C91.9899 86.2476 92.0222 86.3952 92.0822 86.5323C92.1422 86.6694 92.2287 86.7932 92.3369 86.8965C92.445 86.9999 92.5726 87.0807 92.7122 87.1344C92.8518 87.188 93.0006 87.2134 93.15 87.209L94.1753 87.1977C94.4778 87.1984 94.7685 87.0803 94.9849 86.8686C95.2012 86.6569 95.3259 86.3687 95.332 86.0659V84.9636C95.33 84.6543 95.4193 84.3513 95.5886 84.0926C95.7579 83.8338 95.9998 83.6309 96.2839 83.5093C97.2949 83.1072 98.1853 82.4511 98.8692 81.6044C99.5531 80.7576 100.007 79.7488 100.188 78.6751C100.369 77.6014 100.271 76.4992 99.9025 75.4747C99.5341 74.4502 98.9081 73.538 98.085 72.8261C96.8456 71.7357 95.2497 71.1382 93.5996 71.1468C93.3666 71.1468 93.1318 71.1584 92.8952 71.1815",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask3_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M92.1047 64.455L78.7747 80.7844L94.8242 93.9107L108.154 77.5813L92.1047 64.455Z",
						fill: "url(#paint3_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask4_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 92,
					y: 88,
					width: 4,
					height: 2,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M92.1206 88.0717V88.4556C92.1206 88.4734 92.1276 88.4903 92.1401 88.5028C92.1526 88.5154 92.1696 88.5224 92.1873 88.5224C92.205 88.5224 92.2219 88.5154 92.2344 88.5028C92.247 88.4903 92.254 88.4734 92.254 88.4556V88.2019L95.077 88.1665V88.5211L92.1199 89.0286V89.345L95.077 89.3036V89.7042L92.7316 89.7383C92.7139 89.7383 92.6969 89.7453 92.6844 89.7579C92.6719 89.7704 92.6649 89.7874 92.6649 89.8051C92.6649 89.8228 92.6719 89.8397 92.6844 89.8523C92.6969 89.8648 92.7139 89.8718 92.7316 89.8718L95.2105 89.8358V89.1754L92.2546 89.2162V89.1394L95.2105 88.6313V88.0383L92.1206 88.0717Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask4_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M93.3579 86.5176L91.2227 89.1333L93.9739 91.3834L96.1091 88.7677L93.3579 86.5176Z",
						fill: "url(#paint4_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask5_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 92,
					y: 90,
					width: 3,
					height: 2,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M94.8883 90.231C94.8706 90.231 94.8537 90.238 94.8412 90.2505C94.8287 90.263 94.8216 90.2801 94.8216 90.2978C94.8154 90.6002 94.6912 90.8882 94.4757 91.1003C94.2602 91.3124 93.9705 91.4317 93.6683 91.4328C93.5198 91.4382 93.3718 91.4139 93.2329 91.3613C93.094 91.3087 92.967 91.2289 92.8593 91.1265C92.7515 91.0242 92.6653 90.9013 92.6056 90.7652C92.5459 90.6291 92.5139 90.4824 92.5116 90.3338C92.5116 90.3161 92.5045 90.2991 92.492 90.2866C92.4795 90.2741 92.4626 90.267 92.4449 90.267C92.4272 90.267 92.4101 90.2741 92.3976 90.2866C92.3851 90.2991 92.3782 90.3161 92.3782 90.3338C92.3807 90.4997 92.4163 90.6635 92.4829 90.8154C92.5495 90.9674 92.6457 91.1045 92.7659 91.2187C92.8862 91.3329 93.028 91.422 93.183 91.4807C93.3381 91.5393 93.5033 91.5664 93.6689 91.5604C94.0064 91.5589 94.3299 91.4253 94.5703 91.1883C94.8108 90.9513 94.9491 90.6295 94.9557 90.2917C94.9557 90.274 94.9487 90.2571 94.9362 90.2445C94.9237 90.232 94.9067 90.225 94.889 90.225",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask5_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M93.4108 88.9676L91.7212 91.0355L93.9225 92.8375L95.6121 90.7695L93.4108 88.9676Z",
						fill: "url(#paint5_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask6_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 92,
					y: 79,
					width: 4,
					height: 8,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M94.9583 79.4504L93.6722 85.9017L92.5109 79.4537C92.5075 79.4365 92.4974 79.4214 92.4829 79.4115C92.4685 79.4016 92.4507 79.3978 92.4334 79.401C92.4164 79.4039 92.4012 79.4134 92.391 79.4273C92.3808 79.4413 92.3765 79.4587 92.3788 79.4758L93.6028 86.2716C93.6061 86.2868 93.6145 86.3004 93.6267 86.31C93.6389 86.3197 93.654 86.3247 93.6695 86.3244C93.685 86.3247 93.7002 86.3197 93.7124 86.31C93.7245 86.3004 93.733 86.2868 93.7362 86.2716L95.091 79.4744C95.0936 79.4575 95.0896 79.4402 95.0798 79.4262C95.07 79.4121 95.0551 79.4024 95.0384 79.3989H95.0257C95.0102 79.3986 94.9952 79.4036 94.9831 79.413C94.9709 79.4225 94.9624 79.436 94.959 79.451",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask6_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M93.4629 78.0585L88.98 83.55L94.0056 87.6603L98.4885 82.1688L93.4629 78.0585Z",
						fill: "url(#paint6_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask7_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 101,
					y: 82,
					width: 13,
					height: 25,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M103.042 86.4606L101.213 94.0055C101.036 94.7323 101.014 95.4879 101.147 96.2238C101.28 96.9597 101.565 97.6597 101.984 98.2788L107.27 106.091C107.459 106.37 107.718 106.595 108.022 106.742C108.325 106.888 108.662 106.952 108.999 106.927C109.335 106.901 109.658 106.787 109.936 106.596C110.214 106.405 110.437 106.144 110.582 105.839C117.362 91.4636 109.412 82.5157 109.412 82.5157L103.042 86.4606Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask7_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M107.222 74.4722L88.7959 97.7506L110.997 115.357L129.423 92.0791L107.222 74.4722Z",
						fill: "url(#paint7_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask8_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 67,
					y: 66,
					width: 25,
					height: 14,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M68.699 72.6178C68.4356 72.8285 68.2325 73.1051 68.1103 73.4197C67.9881 73.7343 67.9511 74.0755 68.0031 74.409C68.0551 74.7425 68.1943 75.0563 68.4064 75.3186C68.6186 75.581 68.8962 75.7825 69.2113 75.9028L78.0166 79.2687C78.7151 79.536 79.4617 79.654 80.2084 79.6151C80.9552 79.5763 81.6856 79.3814 82.3526 79.043L89.2728 75.5349L91.6549 68.4253C89.2371 67.2992 86.5945 66.7402 83.9282 66.7907C79.8411 66.7907 74.4792 68.0206 68.703 72.6171",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask8_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M76.8388 55.0446L61.2104 74.7883L82.3525 91.5551L97.9808 71.8114L76.8388 55.0446Z",
						fill: "url(#paint8_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask9_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 101,
					y: 81,
					width: 14,
					height: 25,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M103.828 85.4677L101.998 93.0127C101.822 93.7395 101.799 94.495 101.932 95.2309C102.065 95.9669 102.35 96.6669 102.769 97.286L108.056 105.098C108.245 105.378 108.504 105.602 108.808 105.749C109.111 105.896 109.448 105.959 109.784 105.934C110.121 105.908 110.444 105.794 110.722 105.603C111 105.412 111.223 105.151 111.368 104.846C118.148 90.4707 110.198 81.5229 110.198 81.5229L103.828 85.4677Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask9_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M105.244 74.6977L91.4082 100.911L114.547 113.147L128.382 86.9336L105.244 74.6977Z",
						fill: "#A9CEF7"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask10_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 68,
					y: 65,
					width: 25,
					height: 14,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M69.4848 71.6262C69.2212 71.8368 69.0179 72.1134 68.8956 72.428C68.7733 72.7426 68.7363 73.084 68.7883 73.4176C68.8403 73.7511 68.9795 74.065 69.1918 74.3273C69.4041 74.5896 69.6819 74.7911 69.9971 74.9113L78.8025 78.2771C79.5009 78.5444 80.2476 78.6624 80.9943 78.6235C81.7411 78.5847 82.4714 78.3898 83.1384 78.0514L90.0587 74.5433L92.4407 67.4337C90.0229 66.3077 87.3803 65.7486 84.714 65.7992C80.6269 65.7992 75.265 67.0291 69.4888 71.6262",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask10_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M73.585 55.8364L62.9556 75.9762L87.1706 88.7806L97.8001 68.6408L73.585 55.8364Z",
						fill: "#A9CEF7"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask11_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 84,
					y: 37,
					width: 50,
					height: 55,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M100.747 44.9148C90.607 55.162 85.8641 73.7742 85.043 77.2742C84.9563 77.6441 84.8428 78.2437 85.2044 78.3626C91.8899 80.526 97.5717 85.0304 101.207 91.0489C101.416 91.3827 101.985 91.1417 102.335 90.9674C105.595 89.3443 122.566 80.4805 130.2 68.277C138.617 54.8228 130.427 37.741 130.4 37.7364C127.801 37.2236 125.156 36.9775 122.506 37.0019C116.141 37.0019 107.212 38.3814 100.743 44.9168",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask11_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M138.184 32.1915L79.9897 37.4373L85.2757 96.1881L143.47 90.9424L138.184 32.1915Z",
						fill: "#BDD3EC"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask12_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 108,
					y: 36,
					width: 26,
					height: 24,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M108.712 39.5752C113.448 40.5454 118.739 43.6322 123.037 47.0415C127.335 50.4507 131.879 55.367 133.573 59.2938C135.221 49.7116 131.629 40.5147 130.645 38.2612C130.573 38.0969 130.462 37.9527 130.322 37.8413C130.181 37.7299 130.016 37.6546 129.84 37.6222C127.42 37.2018 124.967 36.9942 122.511 37.0019C117.787 36.938 113.096 37.8131 108.712 39.5766",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask12_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M110.434 30.4518L103.218 57.8423L133.498 65.835L140.715 38.4445L110.434 30.4518Z",
						fill: "#A9CEF7"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask13_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 100,
					y: 48,
					width: 25,
					height: 25,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M102.342 52.5747C98.3912 57.5644 99.6766 65.1682 105.21 69.559C110.743 73.9498 118.435 73.463 122.385 68.4733C126.335 63.4836 125.053 55.8798 119.517 51.489C117.134 49.5715 114.175 48.5147 111.118 48.4897C109.441 48.4584 107.779 48.81 106.259 49.5178C104.738 50.2256 103.398 51.2711 102.342 52.5747Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask13_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M109.168 34.8745L86.0103 64.1305L115.559 87.5644L138.717 58.3084L109.168 34.8745Z",
						fill: "url(#paint9_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask14_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 101,
					y: 49,
					width: 23,
					height: 23,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M103.177 53.2378C99.5558 57.8115 100.734 64.7817 105.808 68.8059C110.881 72.8301 117.93 72.3848 121.55 67.811C125.171 63.2373 123.993 56.2672 118.92 52.2429C116.736 50.4852 114.024 49.5164 111.222 49.4933C109.684 49.4646 108.161 49.787 106.767 50.4358C105.373 51.0846 104.145 52.0429 103.177 53.2378Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask14_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M100.748 44.0922L94.6448 71.7438L123.98 78.2312L130.083 50.5796L100.748 44.0922Z",
						fill: "url(#paint10_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask15_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 102,
					y: 50,
					width: 21,
					height: 21,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M104.361 54.1772C101.208 58.1614 102.233 64.2328 106.653 67.7382C111.073 71.2436 117.213 70.8557 120.367 66.8702C123.521 62.8847 122.495 56.8146 118.075 53.3092C116.173 51.778 113.81 50.9342 111.369 50.9141C110.03 50.8892 108.703 51.1699 107.489 51.7351C106.275 52.3003 105.205 53.135 104.361 54.1758",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask15_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M101.314 49.3733L99.8047 71.1467L123.414 72.7859L124.923 51.0125L101.314 49.3733Z",
						fill: "url(#paint11_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask16_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 84,
					y: 77,
					width: 18,
					height: 15,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M84.8243 78.1035C83.7463 79.4649 86.6047 83.5285 91.2081 87.1802C95.8116 90.8318 100.418 92.6881 101.495 91.3267C102.572 89.9652 99.7147 85.9016 95.1112 82.2499C91.5317 79.4116 87.9515 77.6575 86.0283 77.6575C85.8068 77.6352 85.5831 77.6638 85.3744 77.7413C85.1656 77.8187 84.9772 77.9428 84.8237 78.1041",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask16_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M89.6357 68.9196L76.7839 87.9854L96.6833 101.424L109.535 82.3586L89.6357 68.9196Z",
						fill: "#A9CEF7"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask17_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 83,
					y: 80,
					width: 16,
					height: 15,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M85.7146 81.5977L83.7094 82.7328C83.539 82.8294 83.3949 82.9664 83.2897 83.1318C83.1846 83.2973 83.1218 83.486 83.1066 83.6814C83.0915 83.8769 83.1245 84.0731 83.2029 84.2528C83.2812 84.4325 83.4025 84.5901 83.556 84.7118L95.4199 94.1217C95.5734 94.2435 95.7543 94.3257 95.9469 94.3611C96.1395 94.3964 96.3379 94.3839 96.5245 94.3245C96.7111 94.2652 96.8804 94.1609 97.0173 94.0208C97.1542 93.8806 97.2546 93.7089 97.3097 93.5208L97.9568 91.3074C98.2903 90.1668 98.2763 88.9525 97.9163 87.82C97.5563 86.6875 96.8668 85.6883 95.9362 84.9502L92.3587 82.1125C91.4281 81.3745 90.2987 80.9312 89.115 80.8394C87.9313 80.7476 86.7471 81.0114 85.714 81.5971",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask17_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M88.9647 73.152L76.167 89.3197L92.5657 102.325L105.363 86.1571L88.9647 73.152Z",
						fill: "#7284FA"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask18_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 82,
					y: 83,
					width: 15,
					height: 12,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M82.9843 83.4866C81.967 84.7713 84.2224 88.2553 88.022 91.2686C91.8217 94.2819 95.7261 95.6834 96.7427 94.3988C97.7593 93.1141 95.5046 89.6301 91.7049 86.6168C88.8626 84.362 85.9608 83.0112 84.2537 83.0112C84.0202 82.989 83.7846 83.0204 83.565 83.103C83.3454 83.1856 83.1475 83.3172 82.9864 83.4879",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask18_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M83.8135 77.9214L77.8965 94.1998L95.9178 100.763L101.835 84.4843L83.8135 77.9214Z",
						fill: "url(#paint12_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask19_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 84,
					y: 84,
					width: 12,
					height: 10,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M84.6347 84.796C83.8616 85.7722 85.576 88.4202 88.463 90.7104C91.3501 93.0006 94.318 94.0656 95.0904 93.0894C95.8629 92.1132 94.1492 89.4652 91.2621 87.175C89.1021 85.4617 86.8968 84.434 85.5993 84.434C85.4215 84.4168 85.242 84.4406 85.0748 84.5034C84.9075 84.5663 84.7567 84.6666 84.6341 84.7966",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask19_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M85.2651 80.5664L80.7683 92.9377L94.4643 97.9254L98.9611 85.5541L85.2651 80.5664Z",
						fill: "url(#paint13_linear_275_40)"
					})
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask20_275_40",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 33,
					y: 84,
					width: 61,
					height: 41,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M79.7392 91.6225C77.0042 92.4665 74.8803 91.8989 72.8424 91.3314C70.8411 90.7745 68.9206 90.2176 66.5719 90.9975C60.5943 92.9786 62.0398 100.245 56.1235 103.13C52.5974 104.849 49.1093 103.719 45.862 102.587C42.7267 101.496 39.8197 100.406 37.3155 101.874C34.7592 103.373 27.162 110.4 49.6036 120.396C73.0058 129.949 80.9219 117.703 82.084 115.93C85.0424 111.417 80.499 106.248 83.29 102.083C85.1898 99.2496 88.1443 100.379 90.8399 97.0229C92.8545 94.515 93.1813 91.4242 93.1573 89.2602C93.1573 89.2602 90.4284 85.1091 87.4205 84.9535C86.0417 87.2404 83.6089 90.4287 79.7365 91.6245",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					mask: "url(#mask20_275_40)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M42.4915 62.197L18.7656 115.153L82.9887 143.981L106.715 91.0252L42.4915 62.197Z",
						fill: "#CFD5FA"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_275_40",
				x1: 159.649,
				y1: 188.441,
				x2: 159.666,
				y2: 188.406,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9085" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FB6FBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_275_40",
				x1: 160.783,
				y1: 190.335,
				x2: 160.8,
				y2: 190.299,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9085" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FB6FBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_275_40",
				x1: 161.909,
				y1: 192.212,
				x2: 161.925,
				y2: 192.177,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9085" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FB6FBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_275_40",
				x1: 104.747,
				y1: 179.69,
				x2: 104.774,
				y2: 179.658,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#E38DDD" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .004,
						stopColor: "#E38DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#9571F6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_275_40",
				x1: 97.2615,
				y1: 183.43,
				x2: 97.2871,
				y2: 183.399,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#E38DDD" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .004,
						stopColor: "#E38DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#9571F6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_275_40",
				x1: 95.7048,
				y1: 184.149,
				x2: 95.7301,
				y2: 184.118,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#E38DDD" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .004,
						stopColor: "#E38DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#9571F6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_275_40",
				x1: 101.999,
				y1: 181.244,
				x2: 102.026,
				y2: 181.211,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#E38DDD" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .004,
						stopColor: "#E38DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#9571F6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_275_40",
				x1: 99.8585,
				y1: 197.728,
				x2: 99.8769,
				y2: 197.705,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#444B8C" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .996,
						stopColor: "#26264F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#26264F"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_275_40",
				x1: 105.602,
				y1: 166.395,
				x2: 105.634,
				y2: 166.356,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#444B8C" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .996,
						stopColor: "#26264F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#26264F"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint9_linear_275_40",
				x1: 127.495,
				y1: 187.511,
				x2: 127.519,
				y2: 187.482,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#EBEFF2" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .004,
						stopColor: "#EBEFF2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint10_linear_275_40",
				x1: 181.203,
				y1: 168.146,
				x2: 181.215,
				y2: 168.091,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#EBEFF2" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .004,
						stopColor: "#EBEFF2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "white"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint11_linear_275_40",
				x1: 196.309,
				y1: 156.718,
				x2: 196.312,
				y2: 156.675,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#444B8C" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .996,
						stopColor: "#26264F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#26264F"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint12_linear_275_40",
				x1: 125.338,
				y1: 173.652,
				x2: 125.35,
				y2: 173.62,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#AA80F9" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .996,
						stopColor: "#6165D7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#6165D7"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint13_linear_275_40",
				x1: 125.417,
				y1: 173.583,
				x2: 125.43,
				y2: 173.546,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#444B8C" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .996,
						stopColor: "#26264F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#26264F"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_275_40",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 100,
					height: 87,
					fill: "white",
					transform: "translate(34 37)"
				})
			})
		] })
	]
});
export default SvgReportRisk;
